import script from "./ContentEditable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentEditable.vue?vue&type=script&lang=ts&setup=true"

import "./ContentEditable.vue?vue&type=style&index=0&id=59fc92d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fc92d3"]])

export default __exports__